import speedtest_component from '#BASE/components/speedTest/speedTest.component';
import downloadCenterComponent from '#BASE/components/downLoad/DownLoadCenterSKY';
import VueQrcode from '@chenfengyuan/vue-qrcode';
import loginEntryDownload from 'WX/components/Download/loginEntryDownload.component';

export default {
    mixins: [speedtest_component, loginEntryDownload, downloadCenterComponent],
    components: { 
        qrcode: VueQrcode,
    },
    data: function () {
        return {
            MaxShow: 6,        //設定最多顯示
            QrcodeOptions: {
                width: 112,
                margin: 1
            },
            checkSettingComplete: true,
        };
    },
    computed: {
        year(){
            return new Date().getFullYear();
        },
    },
};